import React from 'react'

const ChevronDown = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 20 20" {...props}>
    <path fillOpacity={props.fillOpacity ? props.fillOpacity : ".65"} d="M10.004 11.094L5.015 6.849c-.137-.117-.32-.182-.515-.182-.196 0-.379.065-.516.182l-.437.372c-.137.116-.213.272-.213.438 0 .167.076.323.213.44l5.939 5.054c.138.117.322.181.517.181.197 0 .38-.064.518-.181l5.933-5.05c.138-.117.213-.273.213-.439 0-.166-.075-.322-.213-.439l-.437-.372c-.284-.242-.747-.242-1.031 0l-4.982 4.24z"/>
  </svg>
)

export default ChevronDown
